<template>
  <div class='poptip-item'>
    <poptip :trigger="trigger" :transfer="transfer" :placement="placement" @on-popper-show="$emit('changePopper',item)">
      <slot name="show" v-if="showSlot"></slot>
      <div class="item-box" :class="item.className || className" v-else>
        <div class="item-icon" :class="item.iconClass" v-if="item.iconClass"></div>
        <p class="item-name">{{item.name}}</p>
      </div>
      <div slot="content">
        <div class="poptip-box ovh">
          <p class="fs20 tac poptip-box-title">{{item.type === 'kf' ? '微信扫码添加客服' : '微信扫码关注公众号'}}</p>
          <div class="mlr-auto poptip-box-images ovh">
            <img :src="qrImg[item.type]" alt="" class="w100 h100">
          </div>
          <template v-if="item.type === 'kf'">
            <div v-for="(kf,idx) in kfList" :key="idx" class="tac kfBox">
              <p class="pb10 color_title">{{kf.title}}</p>
              <p class="color_label">{{kf.label}}</p>
            </div>
          </template>
          <template v-else-if="item.type === 'wx'">
            <div v-for="(wx,idx) in wxList" :key="idx" class="wxBox mlr-auto">
              <p class="pb10 wx-title por">{{wx}}</p>
            </div>
          </template>
        </div>
      </div>
    </poptip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

  export default {
    name: 'PoptipItem',
    props: {
      item: {
        type: Object,
        default: {},
      },
      // 触发方式
      trigger: {
        type: String,
        default: 'hover'
      },
      // 显示方向
      placement: {
        type: String,
        default: 'left'
      },
      className: {
        type: String,
        default: ''
      },
      // 显示slot
      showSlot: {
        type: Boolean,
        default: false
      },
      // 显示slot
      transfer: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        // 二维码
        qrImg: {
          kf: '',
          wx: ''
        },
        kfList: [
          {title: '联系电话', label: '', prop: 'phone'},
          {title: '上班时间', label: '周一至周五 9:00~12:00 13:00~18:00'},
        ],
        wxList: ['获取最新活动资讯', '常见问题解答', '电视TV安装指南', '......'],
      }
    },
    computed: {
      ...mapGetters(['kfInfo']),
    },
    watch:{
      kfInfo(val){
        this.getKfInfo();
      }
    },
    created() {
      this.getKfInfo();
    },
    methods: {
      // 获取客服信息
      getKfInfo() {
        this.qrImg.kf = this.kfInfo.customer_code;
        this.qrImg.wx = this.kfInfo.wx_code;
        this.kfList.find(e => e.prop === 'phone').label = this.kfInfo.customer_phone;
      },
    }
  }
</script>

<style scoped lang='less'>
  /deep/ .ivu-poptip-body {
    padding: 0;
  }

  /deep/ .ivu-poptip-inner {
    border-radius: 8px;
  }

  .poptip-box {
    width: 304px;
    height: 344px;
    background: #ffffff;
    border-radius: 8px;
    background: url(../../assets/images/1_pic2.png) no-repeat top left / 100%;
    line-height: 1;
    &-title {
      color: #ffffff;
      padding: 28px 0 16px 0;
      font-weight: bold;
    }

    &-images {
      width: 142px;
      height: 142px;
      box-shadow: 0px 5px 11px 0px rgba(0, 15, 34, 0.08);
      margin-bottom: 17px;
    }
    .color_label {
      font-size: 16px;
      font-weight: 400;
      color: #333f4e;
    }
    .color_title {
      font-size: 14px;
      font-weight: 400;
      color: #999fa6;
    }
    .kfBox {
      padding-bottom: 16px;
    }
    .wxBox {
      width: 130px;
      padding-left: 13px;
      &:last-child {
        .wx-title {
          top: -3px;
        }
        .wx-title::before {
          top: 12px;
        }
      }
    }
    .wx-title {
      font-size: 16px;
      font-weight: 400;
      color: #333f4e;
      &::before {
        content: '';
        width: 6px;
        height: 6px;
        background: #333f4e;
        border-radius: 50%;
        position: absolute;
        top: 8px;
        left: -13px;
        transform: translateY(-50%);
      }
    }
  }
</style>
